import {
  employeeNeedsSalaryMigration,
  normalizeEmployeeSalaryForMigration,
} from './salaryUtils';

/**
 * Migrate all employees in a company from legacy salary split to basic + bonus.
 * @param {Array} employees - company employee list
 * @param {Function} updateEmployee - async (employeeId, data) => { success }
 * @returns {{ migrated: number, skipped: number, errors: string[] }}
 */
export async function migrateCompanyEmployeesSalary(employees, updateEmployee) {
  const result = { migrated: 0, skipped: 0, errors: [] };

  for (const emp of employees || []) {
    if (!emp?.id) continue;
    if (!employeeNeedsSalaryMigration(emp)) {
      result.skipped += 1;
      continue;
    }
    try {
      const payload = normalizeEmployeeSalaryForMigration(emp);
      const res = await updateEmployee(emp.id, {
        basicSalary: String(payload.basicSalaryAmount ?? payload.salary_info?.basic ?? 0),
        bonus: String(payload.bonusAmount ?? payload.salary_info?.bonus ?? 0),
        ...payload,
      });
      if (res?.success) {
        result.migrated += 1;
      } else {
        result.errors.push(`${emp.name || emp.employeeId}: ${res?.error || 'Update failed'}`);
      }
    } catch (e) {
      result.errors.push(`${emp.name || emp.employeeId}: ${e.message}`);
    }
  }

  return result;
}
